import { render, staticRenderFns } from "./AddPolicyModal.vue?vue&type=template&id=1c0c2a1e&scoped=true&"
import script from "./AddPolicyModal.vue?vue&type=script&lang=js&"
export * from "./AddPolicyModal.vue?vue&type=script&lang=js&"
import style0 from "./AddPolicyModal.vue?vue&type=style&index=0&id=1c0c2a1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0c2a1e",
  null
  
)

export default component.exports